import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { AddOnboardingEntitiesModal } from '@/modules/onboarding/common/components/add-entities-modal/add-onboarding-entities-modal';
import { EntityField } from '@/modules/onboarding/common/components/add-entities-modal/types';

import { useUpsertEmployees } from '../../hooks/use-upsert-employees';
import { getMembersSchema, MembersFormData } from './schema';

export interface AddMembersModalProps {
  baseKey?: string;
  onSuccess?: (addedCount: number) => void;
}

export const AddOnboardingMembersModal: React.FC<AddMembersModalProps> = ({
  baseKey = '',
  onSuccess,
}) => {
  const { t } = useTranslation();
  const upsertEmployeesMutation = useUpsertEmployees({ onSuccess });

  const schema = getMembersSchema(t);

  const defaultMemberValues = {
    fullName: '',
    email: '',
  };

  const memberFields: EntityField[] = [
    {
      name: 'fullName',
      label: t('authenticated.onboarding.team:addModal.fullName'),
      placeholder: t('authenticated.onboarding.team:addModal.fullName'),
    },
    {
      name: 'email',
      label: t('authenticated.onboarding.team:addModal.email'),
      placeholder: t('authenticated.onboarding.team:addModal.email'),
    },
  ];

  const transformData = (formData: MembersFormData) => {
    return {
      items: formData.entities.map(member => ({
        email: member.email || undefined,
        name: member.fullName,
      })),
    };
  };

  return (
    <AddOnboardingEntitiesModal
      schema={schema}
      fields={memberFields}
      mutation={upsertEmployeesMutation.mutateAsync}
      transformData={transformData}
      defaultEntityValues={{
        entities: [defaultMemberValues],
      }}
      baseKey={baseKey}
      buttonLabel={t('authenticated.onboarding.team:addModal.addMembers')}
      modalTitle={t('authenticated.onboarding.team:addModal.addMembers')}
      addMoreLabel={t('authenticated.onboarding.team:addModal.addMore')}
      submitLabel={t('authenticated.onboarding.team:addModal.addMembers')}
    />
  );
};
